import { PmStatusEnum, SoStatusEnum } from "@gtpl/shared-models/common-models";

export class AllSaleOrdersDto {
    saleOrderId: number;
    saleOrder: string;
    invDate: Date;
    customer: string;
    poNo: string;
    // brand:string;
    endCustomer: string;
    // address:string;
    destinationAddress: string;
    // deliveryTerms: string;
    // paymentTerms: string;
    // totWeight:number;
    // totAmount:number;
    // styleWeightment : string;
    // certfication:string;
    // soakingTime:string;
    // soakingStyle:string;
    isBrandApproved: string;
    // noOfPouches:string;
    // noOfCartone:string;
    additionalNote: string;
    // sgsInspection:string; 
    // tuvInspection:string;
    // rating:number;
    // isCertified:string;
    brandDesignType: string;
    eta: Date;
    etd: Date;
    // portOfEntry:string;
    // country:string;
    // shippingTerms:string;
    // loadInspection:string;
    category: string;
    status: string;
    pmStatus?: PmStatusEnum;
    unit?: string;
    unitId?: number;
    packingStatus?: string;
    unitCode?: string;
    totalBomQty:number; 
    totalPoQty:number;
    // itemData : SaleOrderItemsDTO[];
    // bomData : BomPackingItemsDto[];
    soStatus?:SoStatusEnum;
    currencyId?:number;
    isTransferred?:boolean;

    /**
     * 
     * @param saleOrder 
     * @param invDate 
     * @param customer 
     * @param poNo 
     * @param endCustomer 
     * @param brand 
     * @param address 
     * @param destinationAddress 
     * @param deliveryTerms 
     * @param paymentTerms 
     * @param totWeight 
     * @param totAmount 
     * @param styleWeightment 
     * @param certfication 
     * @param soakingTime 
     * @param soakingStyle 
     * @param isBrandApproved 
     * @param noOfPouches 
     * @param noOfCartone 
     * @param additionalNote 
     * @param sgsInspection 
     * @param tuvInspection 
     * @param rating 
     * @param isCertified 
     * @param brandDesignType 
     * @param eta 
     * @param etd 
     * @param portOfEntry 
     * @param country 
     * @param itemData 
     */
    constructor(saleOrderId: number, saleOrder: string,
        invDate: Date,
        customer: string,
        poNo: string,
        endCustomer: string,
        // brand:string,
        // address:string,
        destinationAddress: string,
        // deliveryTerms: string,
        // paymentTerms: string,
        // totWeight:number,
        // totAmount:number,
        // styleWeightment : string,
        // certfication:string,
        // soakingTime:string,
        // soakingStyle:string,
        isBrandApproved: string,
        // noOfPouches:string,
        // noOfCartone:string,
        additionalNote: string,
        // sgsInspection:string,
        // tuvInspection:string,
        // rating:number,
        // isCertified:string,
        brandDesignType: string,
        eta: Date,
        etd: Date,
        // portOfEntry,
        // country,
        // shippingTerms,
        // loadInspection,
        category: string,
        status: string,
        pmStatus?: PmStatusEnum,
        unit?: string,
        soStatus?:SoStatusEnum,
        currencyId?:number
        // itemData : SaleOrderItemsDTO[],bomData:BomPackingItemsDto[]
    ) {
        this.saleOrderId = saleOrderId
        this.saleOrder = saleOrder
        this.invDate = invDate
        this.customer = customer
        this.poNo = poNo
        this.endCustomer = endCustomer
        // this.brand=brand
        // this.address=address
        this.destinationAddress = destinationAddress
        // this.deliveryTerms= deliveryTerms
        // this.paymentTerms= paymentTerms
        // this.totWeight=totWeight
        // this.totAmount=totAmount
        // this.styleWeightment= styleWeightment
        // this.certfication=certfication
        // this.soakingTime=soakingTime
        // this.soakingStyle=soakingStyle
        this.isBrandApproved = isBrandApproved
        // this.noOfPouches=noOfPouches
        // this.noOfCartone=noOfCartone
        this.additionalNote = additionalNote
        // this.sgsInspection=sgsInspection
        // this.tuvInspection=tuvInspection
        // this.rating=rating
        // this.isCertified=isCertified
        this.brandDesignType = brandDesignType
        // this.itemData = itemData
        this.eta = eta
        this.etd = etd
        // this.portOfEntry = portOfEntry
        // this.country = country
        // this.shippingTerms = shippingTerms
        // this.loadInspection = loadInspection
        this.category = category
        this.status = status
        this.pmStatus = pmStatus
        this.unit = unit
        this.soStatus = soStatus;
        this.currencyId = currencyId;
        // this.bomData = bomData

    }
}
export class SaleOrderItemsDTO {
    saleOrderItemId: number;
    brand: string;
    minGrade: number;
    maxGrade: number;
    varient: string;
    unitPrice: number;
    packingStyle: string;
    cases: number;
    caseWeight: number;
    netWeight: number;
    netAmount: number;
    uom: string;
    styleWeighment: string;
    minGlaze: number;
    maxGlaze: number;
    soakingTime: string;
    soakingStyle: string;

    constructor(saleOrderItemId: number, minGrade: number, maxGrade: number,
        brand: string,
        varient: string,
        packingStyle: string,
        cases: number,
        caseWeight: number,
        unitPrice: number,
        netWeight: number,
        netAmount: number,
        uom: string,
        styleWeighment: string,
        minGlaze: number,
        maxGlaze: number,
        soakingTime: string,
        soakingStyle: string,) {
        this.saleOrderItemId = saleOrderItemId;
        this.minGrade = minGrade;
        this.maxGrade = maxGrade;
        this.brand = brand;
        this.varient = varient;
        this.packingStyle = packingStyle;
        this.cases = cases;
        this.caseWeight = caseWeight;
        this.netWeight = netWeight;
        this.unitPrice = unitPrice;
        this.netAmount = netAmount;
        this.uom = uom;
        this.styleWeighment = styleWeighment;
        this.minGlaze = minGlaze;
        this.maxGlaze = maxGlaze;
        this.soakingTime = soakingTime;
        this.soakingStyle = soakingStyle;
    }
}

export class BomPackingItemsDto {
    packingMaterialId: number;
    itemCategory: string;
    item: string;
    size: string;
    quantity: number;
    packingCategory: string;
    existingQty: number;
    requiredQty: number;
    receicedQty: number;

    constructor(
        packingMaterialId: number,
        itemCategory: string,
        item: string,
        size: string,
        quantity: number,
        packingCategory: string,
        existingQty: number,
        requiredQty: number,
        receicedQty: number,
    ) {
        this.packingMaterialId = packingMaterialId;
        this.itemCategory = itemCategory;
        this.item = item;
        this.size = size;
        this.quantity = quantity;
        this.packingCategory = packingCategory;
        this.existingQty = existingQty;
        this.requiredQty = requiredQty;
        this.receicedQty = receicedQty;
    }
}